import React from 'react';
import StatusBadge from '../Common/StatusBadge';
import { useLanguage } from '../../contexts/LanguageContext';

const BinaryResolutionItem = ({
	resolution,
	isUpdateAllowed,
	isDeleteAllowed,
	isUpdating,
	onUpdate,
	onDelete,
	onDecrypt,
}) => {
	const { t } = useLanguage();

	const markYes = () => {
		onUpdate(resolution.id, { ...resolution, completed: true }, t);
	};

	return (
		<div className='bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow'>
			<div className='mb-3'>
				<h3 className='text-lg font-semibold text-gray-900 mb-1'>{resolution.text}</h3>
				{resolution.isEncrypted && (
					<span className='inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800'>
						🔒 {t('private')}
					</span>
				)}
			</div>

			<div className='mb-4'>
				<div>
					<div className='flex justify-between items-center mb-2'>
						<span className='text-sm text-gray-600'>{t('progress')}</span>
						<span className='text-sm font-medium'>
							{resolution.statusCode === 'completed' ? t('completed') : t('waiting-completion')}
						</span>
					</div>
					<div className='w-full bg-gray-200 rounded-full h-2'>
						<div
							className='bg-blue-600 h-2 rounded-full transition-all duration-300'
							style={{ width: `${resolution.completed ? 100 : 0}%` }}
						></div>
					</div>
					<div className='text-right mt-1'>
						<span className='text-xs text-gray-500'>{resolution.completed ? 100 : 0}%</span>
					</div>
				</div>
			</div>

			<div className='mb-4'>
				<StatusBadge statusCode={resolution.statusCode} status={t(resolution.statusCode)} />
			</div>

			<div className='flex items-center justify-between'>
				<div className='flex items-center justify-end space-x-2'>
					{isUpdateAllowed && resolution.statusCode !== 'completed' && (
						<div className='mb-4'>
							<div className='flex items-center space-x-3'>
								<button
									onClick={markYes}
									disabled={!isUpdateAllowed || isUpdating}
									className={`px-3 py-1 rounded-md text-sm text-white ${
										resolution.completed ? 'bg-green-500' : 'bg-green-400'
									}`}
								>
									✅ {t('complete')}
								</button>
							</div>
						</div>
					)}
					{resolution.isEncrypted && (
						<button
							onClick={() => onDecrypt(resolution.id)}
							className='px-3 py-1 bg-yellow-500 text-white rounded-md text-sm hover:bg-yellow-600'
						>
							🔓 {t('decrypt')}
						</button>
					)}
				</div>
				{isDeleteAllowed && (
					<button
						onClick={() => onDelete(resolution.id, t)}
						className='px-3 py-1 bg-red-500 text-white rounded-md text-sm hover:bg-red-600'
						title={t('delete')}
					>
						🗑️ {t('delete')}
					</button>
				)}
			</div>
		</div>
	);
};

export default BinaryResolutionItem;
